<div class="input-group">
  @if (label) {
    <div>
      <label>{{label.key | translate}}</label>
    </div>
  }
  <div class="upload">
    @if (!value) {
      <span class="sap-icon">&#xe219;</span>
    }
    @if (!value) {
      <div>
        <a class="file-browse" href="javascript:void(0)">
          {{'Msg.UploadNewFile' | translate}}
          <input type="file" name="file" (change)="onFileSelected($event)" class="file-upload-btn"
            [accept]="accept" [multiple]="multiple">
          </a>
          <br> {{ allowedExtensionsInfo }}
          </div>
        }
        @if (!multiple) {
          @if (value) {
            <div>
              <a class="file-browse" (click)="download()" [title]="fileName">{{fileName}}</a>
              <span>|</span>
              <a class="file-browse" (click)="remove()">{{'Admin.Msg.RemoveButton' | translate}}</a>
            </div>
          }
        }
      </div>
    </div>